import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ParameterDto } from '@src/types/types';
import { Dialog } from '@components/atoms/Dialog';
import { Icon } from '@components/atoms/Icon';
import { IconType } from '@src/types/IconType';
import { Image } from '@components/atoms/Image';
import { StyledMarkdown } from './StyledMarkdown';

//Add back in, when IVARIO wants 4 Tabs again
//type TabType = 'one' | 'two' | 'three' | 'four';
type TabType = 'one' | 'two';

export const ParameterDetailPopup = ({
  parameter,
  onClose,
}: {
  parameter: ParameterDto;
  onClose: () => void;
}) => {
  const { t } = useTranslation('component', { keyPrefix: 'parameterDetail' });
  const [activeTab, setActiveTab] = useState<TabType>('one');

  const tabContent = {
    one: parameter.config?.info1 ?? t('noOneInfoAvailable'),
    two: parameter.config?.info2 ?? t('noTwoInfoAvailable'),
    //Add back in, when IVARIO wants 4 Tabs again
    //three: parameter.config?.info3 ?? t('noThreeInfoAvailable'),
    //four: parameter.config?.info4 ?? t('noFourInfoAvailable'),
  };

  return (
    <Dialog onClose={onClose}>
      <div data-testid="parameter-detail-popup">
        {/* Header with parameter name and category */}
        <div className="flex justify-between items-start mb-8">
          <div className="flex flex-row items-center">
            {parameter.config?.image && (
              <Image
                image={parameter.config.image}
                alt={parameter.name}
                className="w-full max-h-20 max-w-20 object-contain rounded-bonusLarge mr-4"
                sizes="80px"
                lazy={false}
              />
            )}
            <div>
              <h2 className="text-2xl font-bold mb-1">{parameter.name}</h2>
              <p className="text-grey1">{parameter.category}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className=" ml-4 p-2"
            data-testid="close-button"
          >
            <Icon type={IconType.Cross} className="h-4 w-4" />
          </button>
        </div>

        <div className="grid grid-cols-2 gap-2.5 mb-8 min-w-72 lg:w-auto max-w-full">
          {...Object.keys(tabContent).map((key) => (
            <button
              key={key}
              className={`px-4 py-2 font-normal text-dark bg-grey3light border-2 rounded-bonusLarge ${activeTab === key ? 'border-ivarioYellow font-semibold' : 'border-grey3light'}`}
              onClick={() => setActiveTab(key as TabType)}
            >
              {t(`${key}Tab`)}
            </button>
          ))}
        </div>

        {/* Tab content */}
        <div className="relative">
          <div className="h-80 overflow-y-auto pr-4 pb-10">
            <StyledMarkdown markdown={tabContent[activeTab]} />
          </div>
          <div className="absolute bottom-[-2px] left-0 right-0 bg-gradient-to-t from-white to-transparent h-10" />
        </div>
      </div>
    </Dialog>
  );
};
